<template>
  <div>
    <van-tabbar v-if="tabShow == 1" route>
      <van-tabbar-item
        v-for="item in tabList"
        :key="item.id"
        :icon="item.imgUrlTrue"
        :to="item.route"
      >
        <div>{{ item.menuName }}</div>
      </van-tabbar-item>
      <!-- <van-tabbar-item replace to="/recharges" icon="shopping-cart-o">
        充值
      </van-tabbar-item>
      <van-tabbar-item
        v-if="shopShow == 1"
        replace
        to="/shopping"
        icon="shop-o"
      >
        商城
      </van-tabbar-item>
      <van-tabbar-item @click="kefu" icon="smile-comment-o">
        客服
      </van-tabbar-item>
      <van-tabbar-item replace to="/admin" icon="apps-o">管理</van-tabbar-item> -->
    </van-tabbar>
  </div>
</template>

<script>
  import { getAll, clientGet, applyWebList } from "@/api/seting";

  export default {
    name: "Tab",
    data() {
      return {
        //客服链接
        kefuurl: "",
        // 底部tab
        tabShow: "",
        //商城展示
        shopShow: 0,
        tabList: [],
      };
    },
    async created() {
      //获取设置
      await this.getAll();
      //获取设置
      await this.applyWebList();
      //获取链接
      await this.url();
    },
    methods: {
      //获取tab列表
      applyWebList() {
        applyWebList().then((res) => {
          if (res.status) {
            this.tabList = res.data;
          }
        });
      },
      //获取链接
      url() {
        clientGet().then((res) => {
          if (res.status) {
            if (res.data) {
              this.kefuurl = res.data.customerService;
            }
          }
        });
      },
      //系统设置
      getAll() {
        getAll().then((res) => {
          if (res.status) {
            this.tabShow = res.data.footSwitch;
            this.shopShow = res.data.shopSwitch;
          }
        });
      },
      kefu(val) {
        if (val.id == 4) {
          window.location.href = this.kefuurl;
        } else {
          this.$router.push({
            path: val.route,
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
